import { BasicBlock, BasicBlockType, ItemStatus, ItemStatusType } from "../../types/block/enum";
import { ToastKind } from "../../types/toast";

const pastTenseMap: Record<string, string> = {
  create: "created",
  update: "updated",
  plan: "planned",
  delete: "deleted",
  duplicate: "duplicated",
  complete: "completed",
  undo: "undone",
  restore: "restored",
  copy: "copied",
};

type ToastTarget = "Task" | "Event" | "Space";

type ToastMessageParams =
  | { type: typeof ToastKind.DONE; itemStatus: ItemStatusType }
  | { type: typeof ToastKind.DELETE; target: ToastTarget }
  | {
      type: typeof ToastKind.ERROR;
      action: "undo" | "complete" | "delete" | "copy" | "update" | "restore" | "duplicate";
    }
  | { type: typeof ToastKind.COPY }
  | {
      type: typeof ToastKind.SUCCESS;
      action: "create" | "update" | "plan" | "duplicate";
      target: "Task" | "Space" | "Event";
    }
  | { type: typeof ToastKind.RESTORE; target: ToastTarget };

export const getTargetFromBlockType = (blockType: BasicBlockType): "Task" | "Event" => {
  return blockType === BasicBlock.TASK ? "Task" : "Event";
};

export const getActionFromItemStatus = (
  status: ItemStatusType | undefined
): "undo" | "complete" => {
  if (!status) return "complete";
  return status === ItemStatus.IN_PROGRESS ? "undo" : "complete";
};

export const getToastMessageByKind = (params: ToastMessageParams): string => {
  const toPastTense = (action: string) => pastTenseMap[action] || `${action}ed`;

  switch (params.type) {
    case ToastKind.DONE:
      return `Task marked as ${params.itemStatus === ItemStatus.IN_PROGRESS ? "undone" : "done"}`;

    case ToastKind.DELETE:
      return `${params.target} has been deleted`;

    case ToastKind.SUCCESS: {
      const verb = toPastTense(params.action);
      return `${params.target} ${verb} successfully`;
    }

    case ToastKind.ERROR: {
      return `Failed to ${params.action}. Please retry`;
    }

    case ToastKind.COPY:
      return "Successfully copied to clipboard";

    case ToastKind.RESTORE:
      return `${params.target} has been restored`;

    default:
      return "";
  }
};
